// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__DKgRL","float_right":"Toggle_float_right__-xBQx"};